// extracted by mini-css-extract-plugin
module.exports = {"CenteredLoader":"CenteredLoader_CenteredLoader__H9dV-"};